import { render, staticRenderFns } from "./GuideForKid.vue?vue&type=template&id=43836756&"
import script from "./GuideForKid.vue?vue&type=script&lang=js&"
export * from "./GuideForKid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports